var _line, _line2, _line3, _line4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3134",
    "data-name": "Group 3134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.829,
    height: 21.257,
    viewBox: "0 0 17.829 21.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    x2: 2.421,
    y2: 0.779,
    transform: "translate(6.494 7.512)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    x1: 2.421,
    y2: 0.779,
    transform: "translate(8.914 7.512)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    y1: 2.337,
    transform: "translate(8.914 8.291)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    x2: 5.647,
    transform: "translate(6.091 15.304)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3133",
    "data-name": "Group 3133",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3132",
    "data-name": "Group 3132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8479",
    "data-name": "Path 8479",
    d: "M14.714,7.623A6.777,6.777,0,0,0,7.046,1.045,6.778,6.778,0,0,0,1.069,6.67a6.522,6.522,0,0,0,2.9,6.4,2.261,2.261,0,0,1,1.067,1.862v1.012a2.237,2.237,0,0,0,2.275,2.2h1.1a2.237,2.237,0,0,0,2.275-2.2v-.971a2.176,2.176,0,0,1,.972-1.84A6.553,6.553,0,0,0,14.714,7.623Z",
    transform: "translate(1.057 1.057)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.a6e908bd0b9abacce61b1c160fa84439.svg";
export { ForwardRef as ReactComponent };